/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import Prismic from 'prismic-javascript';

import HeroSlider from '../components/Home/HeroSlider';
import Partners from '../components/Home/Partners';
import Explore from '../components/Home/Explore';
import TopRankingsList from '../components/Home/TopRankingList';
import FeaturedEvents from '../components/Home/FeaturedEvents';
import FeaturedProEvents from '../components/Home/FeaturedProEvents';
import Testimonials2 from '../components/Home/Testimonials2';
import FeaturedCardSlider from '../components/Home/FeaturedCardSlider/index';
import Notifications from '../components/Home/Notifications';
import GetInTouch from '../components/Home/GetInTouch';
import Head from '../components/Meta';

import PrivacyPolicyPopup from '../components/Home/PrivacyPolicyPopup';

import RenderPrismicContent from '../components/RenderPrismicContent';

import config, { appHost } from '../config';
import featureFlags from '../flagContainer';
import { getTypes } from '../redux/actions/combined-actions';
import * as homepageActions from '../redux/actions/homepage-actions';
import { getHomepageContent, getHomepageEvents } from '../redux/actions/v2/homepage-actions';
import { getBackgroundClass } from '../utils/styling';

import {
    fetchTopMenByTags,
    fetchTopWomenByTags,
} from '../redux/actions/top-ranked-actions';

import styles from './home.module.scss';

class HomePage extends React.Component {
    static async getInitialProps({ store }) {
        // console.log('Index getInitialProps store.coreUI', store.getState());
        const { homepage, homepageV2, topRanked, coreUI } = store.getState();
        if (!(homepage && homepage.homepageContentLoaded)) {
            await store.dispatch(homepageActions.fetchHomepageContent());
        }

        if (!(homepageV2 && homepageV2.prismicContentLoaded)) {
            await store.dispatch(getHomepageContent());
        }

        if (
            !(
                topRanked &&
                topRanked.men.players.length &&
                topRanked.women.players.length
            )
        ) {
            await store.dispatch(fetchTopMenByTags());
            await store.dispatch(fetchTopWomenByTags());
        }

        if (!(coreUI && coreUI.types)) {
            await store.dispatch(getTypes());
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            // showPolicyPopup: false,
        };

        // this.handleAccept = this.handleAccept.bind(this);
    }

    componentDidMount() {
        const previewRef = Cookies.get(Prismic.previewCookie);
        // const policyAcceptedCookie = Cookies.get('policy-accepted');
        if (previewRef) {
            const previewObj = JSON.parse(previewRef);
            if (previewObj['myutrcom.prismic.io']) {
                this.props.fetchHomepageContent(
                    previewObj['myutrcom.prismic.io'].preview,
                );
            }
        }
        this.props.getHomepageEvents();
        // if (!policyAcceptedCookie) {
        //     this.setState({
        //         showPolicyPopup: true,
        //     });
        // }
    }

    // handleAccept() {
    //     Cookies.set('policy-accepted');
    //     this.setState({
    //         showPolicyPopup: false,
    //     });
    // }

    render() {
        // eslint-disable-next-line no-unused-vars
        const { homepage, homepageV2, topRanked } = this.props;
        const { homepageContent } = homepage;
        const { carouselType } = featureFlags;
        const slides = homepageContent && homepageContent.carousel;
        const partners = homepageContent.feauturedPartners;
        partners && partners.sort((a, b) => a.order - b.order);
        slides && slides.sort((a, b) => a.order - b.order);
        const contentPath = config.staticCdnUrl ? config.staticCdnUrl : '';
        const videoHeroContent = {
            ...homepageContent.heroVideoContent,
            heroImage: {
                video: `${contentPath}${
                    homepageContent.heroVideoContent &&
                    homepageContent.heroVideoContent.video
                }`,
                videoPoster: `${contentPath}${
                    homepageContent.heroVideoContent &&
                    homepageContent.heroVideoContent.videoposter
                }`,
            },
        };

        const themeV2 = featureFlags.themeV2.isEnabled();

        console.log('homepage props', this.props);

        return (
            <div className={`home-page ${styles.homePage} ${themeV2 && getBackgroundClass(homepageV2.prismicContent)}`} key={Math.random()}>
                <Head title="Universal Tennis" />
                {themeV2 ? (
                    <>
                        <RenderPrismicContent contentSlices={homepageV2.prismicContent} />
                    </>
                ) : (
                    <>
                        {homepageContent && homepageContent.notifications && (
                            <Notifications
                                homedashNotifications={
                                    homepageContent.notifications
                                }
                            />
                        )}
                        <Explore
                            exploreItems={homepageContent.explore}
                            applySearchFilters={this.props.applySearchFilters}
                            clearFilters={this.props.clearFilters}
                            history={this.props.history}
                            title={`Explore`}
                            className={`mb40`}
                        />
                        <HeroSlider
                            slides={slides}
                            authed={this.props.user !== null}
                            history={this.props.history}
                        />
                        <FeaturedCardSlider
                            featuredCards={homepageContent.featuredCardSlider}
                        />
                        <TopRankingsList featureFlags={featureFlags} />
                        {!!(
                            homepageContent &&
                            homepageContent.featured &&
                            homepageContent.featured.events &&
                            homepageContent.featured.events.length
                        ) && (
                            <FeaturedEvents
                                featuredEvents={homepageContent.featured.events}
                            />
                        )}
                        {!!(
                            homepageContent && homepageContent.featuredProEvents
                        ) && (
                            <FeaturedProEvents
                                featuredProEvents={
                                    homepageContent.featuredProEvents
                                }
                            />
                        )}
                        <Testimonials2
                            testimonials={homepageContent.testimonials}
                        />
                        <Partners />
                        <GetInTouch />
                    </>
                )}
                {/* {this.state.showPolicyPopup === true && (
                    <PrivacyPolicyPopup
                        handleClose={() => this.setState({ showPolicyPopup: false })}
                        history={this.props.history}
                        handleAccept={this.handleAccept}
                    />
                )} */}
            </div>
        );
    }
}

function mapStateToProps({ homepage, homepageV2, coreUI }) {
    return { homepage, homepageV2, coreUI };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchHomepageContent: (token) => {
            dispatch(homepageActions.fetchHomepageContent(token));
        },
        getHomepageEvents: () => {
            dispatch(getHomepageEvents());
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
